import React from "react";

const PrivacySection = () => {
  return (
    <section className="faq_area bg_color sec_pad">
      <div className="container">
        <div
          className="row"
          style={{ justifyContent: "center", placeContent: "center" }}
        >
          <div className="col-lg-8">
            <div className="tab-content faq_content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="purchas"
                role="tabpanel"
                aria-labelledby="purchas-tab"
              >
                <h3 className="f_p f_size_22 f_500 t_color3 mb_20">
                  Terms and Conditions for Urdoer
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      Welcome to the Urdoer. These Terms and Conditions
                      ("Terms") govern the rights and responsibilities of the
                      Doers ("Doers") using the Platform. By accessing and using
                      the Platform, you agree to be bound by these Terms. If you
                      do not agree with any part of these Terms, you should
                      refrain from using the Platform.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  1. Doers' Agreement
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      1.1 By using the Platform, you confirm that you are at
                      least 18 years old or have the consent of a legal guardian
                      to use the Platform.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      1.2 You agree to provide accurate and complete information
                      when registering or using the Platform's services.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  2. Solving tasks
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      2.1 The Platform provides a marketplace where Doers can
                      offer their task-solving services to users seeking
                      assistance.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      2.2 Doers must deliver high-quality work that meets the
                      user's requirements and academic standards.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      2.3 Doers should not engage in any unethical practices,
                      such as plagiarism or academic misconduct, while providing
                      task-solving services.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  3. Intellectual Property
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      3.1 Doers confirm that the work they provide is original
                      and does not infringe upon any intellectual property
                      rights or violate any academic integrity policies.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      3.2 Doers retain the copyright to the work they produce.
                      However, by using the Platform, Doers grant the users a
                      non-exclusive, worldwide, royalty-free license to use,
                      reproduce, and modify the work solely for their
                      educational purposes.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  4. Payment and Compensation
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      4.1 Doers agree to receive compensation for their services
                      as agreed upon with the users or in accordance with the
                      pricing set by the Platform.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      4.2 Doers acknowledge that the Platform may deduct a
                      service fee or commission from the total compensation.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      4.3 Doers are responsible for complying with any tax
                      obligations resulting from the compensation received
                      through the Platform.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  5. Confidentiality and Privacy
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      5.1 Doers agree to maintain the confidentiality of any
                      user information or materials provided for task solving.
                      Doers must not disclose or share such information with
                      third parties.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      5.2 Doers should not use or disclose any personally
                      identifiable information obtained through the Platform for
                      any purpose other than completing the assigned task.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      5.3 Doers must adhere to the Platform's Privacy Policy
                      regarding the collection, storage, and use of user
                      information.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  6. Communication and Professionalism
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      6.1 Doers should maintain professional and respectful
                      communication with users. Any disputes or disagreements
                      should be resolved in a civil and constructive manner.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      6.2 Doers should respond promptly to user inquiries or
                      messages related to the assigned task.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  7. Liability and Indemnification
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      7.1 Doers are solely responsible for the quality,
                      accuracy, and integrity of the work they provide. The
                      Platform does not guarantee the correctness or suitability
                      of the solutions.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      7.2 Doers agree to indemnify and hold the Platform
                      harmless from any claims, damages, or liabilities arising
                      from their actions, omissions, or breach of these Terms.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  8. Modification of Terms
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      8.1 The Platform may update or modify these Terms at any
                      time. Doers will be notified of significant changes via
                      email or prominent notices on the Platform.
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      8.2 By continuing to use the Platform after the
                      modification of the Terms, Doers accept and agree to be
                      bound by the updated Terms.
                    </div>
                  </div>
                </div>
                <h3 className="f_p f_size_22 f_500 t_color3 mb_20">
                  9. Termination of Service
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      9.1 The Platform reserves the right to suspend or
                      terminate a Solver's account for violation of these Terms
                      or any illegal or inappropriate activities.
                    </div>
                  </div>
                </div>
                <h3
                  className="f_p f_size_22 f_500 t_color3 mb_20 mt_100"
                  style={{ marginTop: "50px" }}
                >
                  10. Governing Law
                </h3>
                <div id="accordion">
                  <div className="card" style={{ border: "none" }}>
                    <div
                      className="card-body"
                      style={{ padding: "0px 0px 15px" }}
                    >
                      10.1 These Terms shall be governed by and construed in
                      accordance with the laws of [Your Country/Region].
                    </div>
                  </div>
                  <div className="card" style={{ border: "none" }}>
                    <div
                      id="collapseOne"
                      className="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div
                        className="card-body"
                        style={{ padding: "0px 0px 15px" }}
                      >
                        By using the Platform, you acknowledge that you have
                        read
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default PrivacySection;
